var _path, _path2, _path3, _path4, _path5, _path6, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg001CompletedTask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m32 16h352c17.671875 0 32 14.328125 32 32v432c0 17.671875-14.328125 32-32 32h-352c-17.671875 0-32-14.328125-32-32v-432c0-17.671875 14.328125-32 32-32zm0 0",
    fill: "#ecce93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m32 374.625v-326.625h352v432h-246.625zm0 0",
    fill: "#efefef"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m137.375 374.625v105.375l-105.375-105.375zm0 0",
    fill: "#e76e54"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m128 64v-64h160v64c0 17.671875-14.328125 32-32 32h-96c-17.671875 0-32-14.328125-32-32zm0 0",
    fill: "#e76e54"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m512 368c0 79.527344-64.472656 144-144 144s-144-64.472656-144-144 64.472656-144 144-144 144 64.472656 144 144zm0 0",
    fill: "#48c8ef"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m335.007812 429.648438-31.007812-31.023438c-6.246094-6.25-6.246094-16.378906 0-22.625s16.375-6.246094 22.625 0l10.367188 10.351562 72.464843-60.398437c6.789063-5.664063 16.886719-4.746094 22.542969 2.046875 5.664062 6.789062 4.746094 16.886719-2.046875 22.542969zm0 0",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#77959e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m176 128h128c8.835938 0 16 7.164062 16 16s-7.164062 16-16 16h-128c-8.835938 0-16-7.164062-16-16s7.164062-16 16-16zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 128h32v32h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 192h32v32h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 256h32v32h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96 320h32v32h-32zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176 192h96c8.835938 0 16 7.164062 16 16s-7.164062 16-16 16h-96c-8.835938 0-16-7.164062-16-16s7.164062-16 16-16zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176 256h32c8.835938 0 16 7.164062 16 16s-7.164062 16-16 16h-32c-8.835938 0-16-7.164062-16-16s7.164062-16 16-16zm0 0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg001CompletedTask);
export default __webpack_public_path__ + "static/media/001-completed-task.84984effce0370b42e277faa0f07a4ef.svg";
export { ForwardRef as ReactComponent };